// @flow

import { get } from '../utils/api';

// The Certification Approvals screen's endpoints. All are frozen against the
// contract fixtures (stages.json / counts.json / certs-in-stage.json):
//   - the stage list is a global lookup (structure, order, grouping, the
//     bar-versus-row flag, and the default selected stage), so it takes no
//     property scope — like the other lookup endpoints in this app
//     (e.g. /compliance-statuses).
//   - the counts and the certs-in-a-stage list are tenant-scoped under the
//     standard `/{organizationId}/{propertyId}/` path, matching every other
//     property-scoped endpoint in this app (the backend added org/property to
//     the path with permission scoping to close a cross-org data-exposure
//     hole). The backend applies the open-certs filter and the scope; the
//     frontend only supplies the org and property it already holds.
//   - the certs-in-a-stage list is paginated (page / pageSize stay as query
//     params) and returns one page of cards for a single stage, scoped to the
//     same org + property as the counts — so a funnel bar reading N and the
//     panel it opens listing N stay in agreement.
export default class ComplianceApprovalService {
  getStages(options?: Object) {
    return get('/compliance-approval/stages', options);
  }

  getCounts(organizationId: string, propertyId: string, options?: Object) {
    return get(
      `/${organizationId}/${propertyId}/compliance-approval/counts`,
      options,
    );
  }

  getCertsInStage(
    {
      organizationId,
      propertyId,
      stageKey,
      page,
      pageSize,
    }: {
      organizationId: string,
      propertyId: string,
      stageKey: string,
      page: number,
      pageSize: number,
    },
    options?: Object,
  ) {
    return get(
      `/${organizationId}/${propertyId}/compliance-approval/stage/${encodeURIComponent(
        stageKey,
      )}/certs?page=${page}&pageSize=${pageSize}`,
      options,
    );
  }
}
